import { Button, Chip, IconName, Stack, Tag, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';

interface ConflictsListProps {
    entities: { id: string; name: string }[];
    title: React.ReactNode;
    handleDeselectEntity?: (id: string) => void;
    handleDeselectAllEntities?: () => void;
    dataTestId?: string;
}

const MAX_DISPLAYED_ENTITIES = 9;

export const ConflictsList = ({
    entities,
    title,
    handleDeselectEntity,
    handleDeselectAllEntities,
    dataTestId,
}: ConflictsListProps) => {
    if (entities.length === 0) return null;
    return (
        <Stack vertical spacing="100" data-test-id={dataTestId}>
            <Stack distribution="space-between" itemAlignment="center">
                <Typography textStyle="bodyMediumStrong" as="div">
                    {title}
                    {UnicodeEntity.NoBreakSpace}
                    {UnicodeEntity.LeftParenthesis}
                    {entities.length}
                    {UnicodeEntity.RightParenthesis}
                </Typography>
                {handleDeselectAllEntities != null && (
                    <Button
                        variant="ghost"
                        icon={IconName.CrossClose}
                        onClick={handleDeselectAllEntities}
                        type="submit"
                    >
                        <Typography textStyle="bodyMediumStrong" as="div">
                            {lt(TextKey.RoutingRulesFormCompaniesDialogClearAll)}
                        </Typography>
                    </Button>
                )}
            </Stack>
            <Stack spacing="100" wrap>
                {entities.slice(0, MAX_DISPLAYED_ENTITIES).map((entity) =>
                    handleDeselectEntity != null ? (
                        <Chip
                            key={entity.id}
                            value={entity.id}
                            onRemove={() => {
                                handleDeselectEntity(entity.id);
                            }}
                        >
                            {entity.name}
                        </Chip>
                    ) : (
                        <Tag variant="basicSubtle" key={entity.id}>
                            {entity.name}
                        </Tag>
                    )
                )}
                {entities.length > MAX_DISPLAYED_ENTITIES && (
                    <Tag variant="basicBold">
                        {UnicodeEntity.PlusSign}
                        {entities.length - MAX_DISPLAYED_ENTITIES}
                    </Tag>
                )}
            </Stack>
        </Stack>
    );
};
